import { render } from "./videoDialog.vue?vue&type=template&id=6bc4daeb&scoped=true"
import script from "./videoDialog.vue?vue&type=script&lang=js"
export * from "./videoDialog.vue?vue&type=script&lang=js"

import "./videoDialog.vue?vue&type=style&index=0&id=6bc4daeb&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bc4daeb"]])

export default __exports__